import React from 'react';
import CheckboxRadioButtons from '@ignitesales/react-bootstrap4-checkbox-radio-buttons';
import { QuestionTypeViewPropTypes } from '../../../shapes/index.mjs';
import QuestionText from '../../questions/QuestionText.jsx';
import { getQuestionAnswersArray } from '../../../util/questionUtil.jsx';
import PropTypes from 'prop-types';

const CheckboxRadioButton = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = [] } = {},
    type
  } = props;

  const {
    appkey
  } = question;

  return (
    <div className={ className } id={ appkey }>
      <QuestionText question={ question }/>
      <CheckboxRadioButtons
        name={ appkey }
        onChange={ valueChanged }
        type={ type }
        checkedValues={ value }
        answerOptions={ getQuestionAnswersArray(question) }
      />
    </div>
  );
};

CheckboxRadioButton.propTypes = {
  ...QuestionTypeViewPropTypes,
  type: PropTypes.oneOf([ 'radio', 'checkbox' ])
};

export default CheckboxRadioButton;
